export default {
  bind(el, {value}) {
    if (typeof value !== 'function') {
      throw new Error('v-clickOutside value must be Function!!!')
    }
    el.bodyClick = e => {
      if (!el.contains(e.target)) value()
    }
    document.addEventListener('click', el.bodyClick)
  },
  unbind(el) {
    document.removeEventListener('click', el.bodyClick)
    delete el.bodyClick
  }
}
